import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { selectAuth, selectEventsListIsLoaded, selectEventsListIsLoading } from '@/store/selectors';
import { getEvents } from '@/store/thunks/events';
import { useEffect } from 'react';

type TUseApp = {
    auth: boolean
}

export const useApp = (): TUseApp => {
    const auth = useAppSelector(selectAuth);
    const dispatch = useAppDispatch();

    const eventsIsLoading = useAppSelector(selectEventsListIsLoading);
    const eventsIsLoaded = useAppSelector(selectEventsListIsLoaded);

    useEffect(() => {
        if (auth && !(eventsIsLoaded || eventsIsLoading)) {
            dispatch(getEvents());
        }
    }, [eventsIsLoaded, eventsIsLoading, dispatch, auth]);

    return { auth };
};
